import React from "react";

const STATUS_STYLES = {
    active: { text: "text-emerald-400", border: "border-emerald-400/30" },
    inactive: { text: "text-zinc-400", border: "border-zinc-400/30" },
    revoked: { text: "text-red-400", border: "border-red-400/30" },
    queued: { text: "text-sky-400", border: "border-sky-400/30" },
    processing: { text: "text-amber-400", border: "border-amber-400/30" },
    completed: { text: "text-emerald-400", border: "border-emerald-400/30" },
    failed: { text: "text-red-400", border: "border-red-400/30" },
    webhook_pending: { text: "text-amber-400", border: "border-amber-400/30" },
    webhook_delivered: { text: "text-emerald-400", border: "border-emerald-400/30" },
    webhook_failed: { text: "text-red-400", border: "border-red-400/30" },
};

export default function StatusBadge({ status, className = "" }) {
    const s = STATUS_STYLES[status] || STATUS_STYLES.inactive;
    return (
        <span
            data-testid={`status-badge-${status}`}
            className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-sm bg-white/5 border ${s.border} ${s.text} font-mono text-[11px] tracking-wide uppercase ${className}`}
        >
            <span className={`w-1.5 h-1.5 rounded-full ${s.text.replace("text-", "bg-")}`} />
            {status?.replace(/_/g, " ")}
        </span>
    );
}
